export default {
  pagesTitle:
    "Excoino | Currency strict | Excoino official website-global bitcoin trading platform | Global digital currency trading platform",
  loginTip: "لطفا ابتدا وارد شوید",
  searchPlaceHolder: "جستجو ...",
  logout: "خروج",
  tip: "نکته‌های مهم:",
  nodata: "داده ای ثبت نشده است",
  more: "همه",
  please: "لطفا",
  pleaseSelect: "انتخاب کنید",
  loadingText: "در حال بارگذاری نتایج، لطفا صبر کنید",
  getRealized: "متوجه شدم",
  excoino: "اکسکوینو",
  messages: "پیام ها",
  noMessage: "شما پیامی ندارید",
  searchNameCoin: "جستجو براساس نام ارز و یا نام اختصاری...",
  show: "نمایش",
  removeFilter: "حذف فیلتر",
  showAllCoins: "نمایش همه ارزها",
  day: "روز",
  Withdrawal: "انصراف",
  Return: "بازگشت",
  Enable: "فعالسازی",
  Disable: "غیرفعالسازی",
  Time: "زمان",
  Reward: "پاداش",
  Date: "تاریخ",
  free: "رایگان",
  from: "از",
  until: "تا",
  until_2: "الی",
  TERMINATED: "پایان یافته",
  IN_PROGRESS: "در حال جریان",
  ACTIVATE: "فعال",
  DISABLED: "غیرفعال",
  registrationClosed: "اتمام مهلت ثبت نام"
};
